import {useState} from "react";
import toast from "react-hot-toast";
import SingleLabView from "./SingleView";
import MultipleLabView from "./MultipleView";
import EmptyLabState from "./EmptyState";
import ViewModeToggler from "./ViewModeToggler";

const TranscriptionsLabView = ({transcriptions, transcriptionsEndRef}) => {
    const [viewMode, setViewMode] = useState('single');

    /* -------------------- Toggle View Mode -------------------- */
    const toggleViewMode = () => {
        setViewMode(prev => prev === 'single' ? 'multiple' : 'single');
        toast.success(`Switched to ${viewMode === 'single' ? 'conversational' : 'block'} bubble view`, {
            position: 'bottom-center',
            duration: 2000,
            icon: viewMode === 'single' ? '💬' : '📃'
        });
    };

    if (transcriptions.length === 0) return <EmptyLabState/>

    return (
        <>
            <ViewModeToggler toggleViewMode={toggleViewMode} viewMode={viewMode}/>

            {
                viewMode === 'single' ?
                    <SingleLabView
                        transcriptions={transcriptions}
                        transcriptionsEndRef={transcriptionsEndRef}
                    />
                    :
                    <MultipleLabView
                        transcriptions={transcriptions}
                        transcriptionsEndRef={transcriptionsEndRef}
                    />
            }

        </>
    );
}

export default TranscriptionsLabView;